import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '@/integrations/supabase/client';

export function useWealthicaOpenPosition(
  userId: string | undefined,
  setPositionSummary: (summary: any) => void,
  setShowDetailDrawer: (open: boolean) => void,
) {
  const navigate = useNavigate();

  return useCallback(async (pos: any) => {
    try {
      const symbol: string | undefined = pos?.security?.symbol || pos?.symbol || undefined;
      const name: string | undefined = pos?.security?.name || pos?.name || undefined;

      if (userId && (symbol || name)) {
        let assetId: string | null = null;
        if (symbol) {
          const { data } = await supabase
            .from('assets_unified_view')
            .select('id')
            .eq('user_id', userId)
            .eq('symbol', symbol)
            .limit(1)
            .maybeSingle();
          if (data?.id) assetId = data.id;
        }
        if (!assetId && name) {
          const { data } = await supabase
            .from('assets_unified_view')
            .select('id')
            .eq('user_id', userId)
            .eq('asset_name', name)
            .limit(1)
            .maybeSingle();
          if (data?.id) assetId = data.id;
        }

        if (assetId) {
          navigate('/assets', { state: { openAssetId: assetId } });
          return;
        }
      }
    } catch {
      // fall through to local drawer
    }

    const inv = Array.isArray(pos.investments) ? pos.investments[0] : undefined;
    const summary = {
      name: pos.security?.name || pos.name || 'Security',
      symbol: pos.security?.symbol || pos.symbol || '',
      quantity: pos.quantity ?? inv?.quantity,
      market_value: pos.market_value ?? inv?.market_value,
      currency: pos.currency ?? inv?.currency ?? 'CAD',
      accountId: inv?.investment || pos.account_id
    };
    setPositionSummary(summary);
    setShowDetailDrawer(true);
  }, [navigate, setPositionSummary, setShowDetailDrawer, userId]);
}
